// extracted by mini-css-extract-plugin
export default {"container":"ReviewPage_container__AgtHi","loading":"ReviewPage_loading__VxiY8"};